/**
 * Browser cookie for Samsung / FRAPI COUPON promo state (fuel-cart only).
 * OL documents the same name for alignment; OL does not set this cookie.
 *
 * Payload is JSON: `{ version, quoteId, available, selected }`.
 * OneTrust: written via `setCookie` with `otGroup: "C0003"` (same pattern as quoteId / return visitor).
 */
export const SWEETENER_COUPON_OFFER_COOKIE_NAME = "sweetenerCouponOffer" as const;

export const SWEETENER_COUPON_OFFER_COOKIE_VERSION = "1" as const;

export type SweetenerCouponOfferCookiePayload = {
  version: typeof SWEETENER_COUPON_OFFER_COOKIE_VERSION;
  quoteId: string;
  /** At least one cart broadband product includes `samsung-best-buy-coupon` from OL. */
  available: boolean;
  /** User selected a broadband plan that included that sweetener. */
  selected: boolean;
};
